import React, { useState, useEffect } from "react";
import { X } from "react-bootstrap-icons";
import "../../Custom.css"; // custom styles

const UserAttributeDrawer = ({ isOpen, onClose, onSave, initialData }) => {
  const [attribute, setAttribute] = useState("");
  const [condition, setCondition] = useState("equals");
  const [value, setValue] = useState("");

  useEffect(() => {
    if (initialData) {
      setAttribute(initialData.attribute || "");
      setCondition(initialData.condition || "equals");
      setValue(initialData.value || "");
    }
  }, [initialData]);

  const handleSave = () => {
    onSave({
      attribute,
      condition,
      value,
      label: `${attribute} ${condition} ${value}`,
    });
    onClose();
  };

  const conditions = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Does not equal" },
    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Does not contain" },
    { value: "greater_than", label: "Greater than" },
    { value: "less_than", label: "Less than" },
  ];

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="drawer-overlay" onClick={onClose}></div>}

      {/* Drawer */}
      <div className={`drawer drawer-md ${isOpen ? "open" : ""}`}>
        <div className="drawer-content">
          {/* Header */}
          <div className="drawer-header d-flex justify-content-between align-items-center border-bottom p-3 bg-light">
            <h5 className="mb-0">Change in User Attribute</h5>
            <button className="btn btn-link text-muted p-0" onClick={onClose}>
              <X size={22} />
            </button>
          </div>

          {/* Body */}
          <div className="drawer-body p-3 flex-grow-1 overflow-auto">
            <div className="mb-3">
              <label className="form-label">Attribute</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter attribute name"
                value={attribute}
                onChange={(e) => setAttribute(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Condition</label>
              <select
                className="form-select"
                value={condition}
                onChange={(e) => setCondition(e.target.value)}
              >
                {conditions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Value</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>
          </div>

          {/* Footer */}
          <div className="drawer-footer border-top p-3 bg-light">
            <button
              className="btn btn-info w-100 text-white"
              onClick={handleSave}
            >
              Save & Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserAttributeDrawer;
